// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"72e1197d","453":"db3e927e","454":"b6b2bcb3","702":"540cc676"}[chunkId] + ".chunk.js";
};